import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOpportunityMSContactListData } from './mockData'
import type { IOpportunityMSContact } from '@/types/opportunity/models'

interface GetOpportunityMSContactsResponse {
  data: IOpportunityMSContact[] | undefined
}

const postOpportunityMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOpportunityMSContactListData)
}

const patchOpportunityMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOpportunityMSContactListData)
}

const deleteOpportunityMSContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOpportunityMSContactListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/opportunitymscontacts',
    handler: postOpportunityMSContact,
  },
  {
    method: 'patch',
    path: '/api/opportunitymscontacts/:id',
    handler: patchOpportunityMSContact,
  },
  {
    method: 'delete',
    path: '/api/opportunitymscontacts/:id',
    handler: deleteOpportunityMSContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
